/**
 * 日時整形ユーティリティ
 *
 * API レスポンスの `YYYY-MM-DD HH:mm:ss` 形式を、画面表示用に
 * `YYYY/MM/DD HH:mm`（年月日 時:分）に整形する。
 *
 * - 区切り文字 `-` を `/` に統一
 * - 秒を切り捨て（時刻のあるケースのみ）
 * - 「日程調整中」「-」「空文字」「undefined / null」は破壊せず素通し
 */

export const formatDateTimeMinute = (
  dateStr: string | null | undefined,
): string => {
  if (dateStr === null || dateStr === undefined) return '';
  if (dateStr === '') return '';

  // スペースで日付・時刻を分割（API: "YYYY-MM-DD HH:mm:ss"）
  const [datePart, timePart] = dateStr.split(' ');

  // 日付として妥当か（数字+区切り のみで構成されるか）の簡易判定。
  // 「日程調整中」「-」など API 由来の特殊文字列はそのまま返す。
  const looksLikeDate = /^\d{4}[-/]\d{1,2}[-/]\d{1,2}$/.test(datePart);
  if (!looksLikeDate) return dateStr;

  const formattedDate = datePart.replace(/-/g, '/');
  if (!timePart) return formattedDate;

  // 時刻部分は先頭 5 文字（HH:mm）のみ採用して秒を切り捨てる
  const formattedTime = timePart.substring(0, 5);
  return `${formattedDate} ${formattedTime}`;
};
